import Details from './Details';
import View from './View';
import Widgets from './Widgets';
import ConnectButtonAnalytics from './ConnectButtonAnalytics';
import Location from './Location';
import Actions from './Actions';
import styles from './QrInformation.module.css';

export default function QrInformation() {

    return (
        <div className={styles.container}>
            <Details />
            <View />
            <Widgets />
            <ConnectButtonAnalytics />
            <div className={styles.locationActionWrap}>
                <Location />
                <Actions />
            </div>
        </div>
    );
};
